import { RESOURCES } from 'api/common/constants';
import apiClient from '../client';
import client from '../client';
import { BASE_ENDPOINTS, SERVICES, VERSIONS } from '../common/constants';

// Define the base endpoint for crop infection
const CROP_INFECTION_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.CROPINFECTION,
  false // No tenant ID in the base URL
);

export const getFormList = tns_tenant =>
  client.get(`${CROP_INFECTION_BASE}/rule/form`);

export const submitInfection = ({ tns_tenant, combinedData }) =>
  client.post(`${CROP_INFECTION_BASE}/rule`, combinedData);

export const getinfectionReport = ({
  cursor,
  limit,
  tenant,
  diseaseIds,
  pestIds,
  search_text
}) =>
  client.post(`${CROP_INFECTION_BASE}/alerts`, {
    disease_ids: diseaseIds,
    pest_ids: pestIds,
    cursor: cursor,
    limit: limit,
    search_text: search_text
  });

export const cropInfectionApi = {
  // Fetch table data
  getInfectionRuleReport: (tenantId, params) =>
    apiClient.post(`${CROP_INFECTION_BASE}/rule/report`, params),

  // Fetch dynamic form for creation
  getDynamicForm: (tenantId, ruleId, isEdit) =>
    apiClient.get(
      `${CROP_INFECTION_BASE}/rule/form?is_edit=${isEdit}&rule_id=${ruleId}`
    ),

  // Create new infection rule
  createRule: (tenantId, data) =>
    apiClient.post(`${CROP_INFECTION_BASE}/rule`, data),

  // Fetch edit form data
  getEditFormData: (tenantId, ruleId, isEdit) =>
    apiClient.get(
      `${CROP_INFECTION_BASE}/rule/form?is_edit=${isEdit}&rule_id=${ruleId}`
    ),

  // Submit edited data
  updateRule: (tenantId, ruleId, data) =>
    apiClient.put(`${CROP_INFECTION_BASE}/rule/${ruleId}`, data),

  // Delete infection rule
  deleteRule: (tenantId, ruleId) =>
    apiClient.delete(`${CROP_INFECTION_BASE}/rule/${ruleId}`)
};
